import { GqlClientService } from '@/common/network/gql-client-service'
import * as op from '../../common/errors/OperationResult'
import { type OperationResult } from '@/common/errors/OperationResult'
import { SpaceGqlModel } from '../gql/SpaceGqlModel'
import type { CreateSpaceInput } from '../gql/CreateSpaceInput'

type CreateSpaceResponse = { createSpace: SpaceGqlModel }

export class SpacesApiService {
  constructor(private readonly gqlClientService: GqlClientService) {}

  public async createSpace(spaceName: string): Promise<OperationResult<SpaceGqlModel>> {
    const query = `mutation($input: CreateSpaceInput!) {
  createSpace(input: $input) {
    id,
    name
  }
}`
    const { result: body, error } = await this.gqlClientService.sendGqlRequest<CreateSpaceResponse>(
      query,
      {
        variables: {
          input: { name: spaceName } as CreateSpaceInput,
        },
      },
    )

    const createdSpace = body!.data!.createSpace

    if (error) {
      return op.error(error)
    }

    return op.success(createdSpace)
  }
}
